import React from "react";
import { Tabs } from "antd-mobile";
import * as styles from "./styles/index.scss"
import win10_1 from "@assets/img/wizard/win10_1.png"
import win10_2 from "@assets/img/wizard/win10_2.png"
import win10_3 from "@assets/img/wizard/win10_3.png"
import win10_4 from "@assets/img/wizard/win10_4.png"
import win11_1 from "@assets/img/wizard/win11_1.png"
import win11_2 from "@assets/img/wizard/win11_2.png"
import win11_3 from "@assets/img/wizard/win11_3.png"
import win11_icon1 from "@assets/img/wizard/win11_icon1.png"
import win11_icon2 from "@assets/img/wizard/win11_icon3.png"
import win10_icon1 from "@assets/img/wizard/icon1.png"
import win10_icon2 from "@assets/img/wizard/icon2.png"
export default class Wizard extends React.Component<any>{
    render(): React.ReactNode {
        const tabList = [{
            name: '1',
            title: 'Win10'
        },
        {
            name: '2',
            title: 'Win11'
        }]
        return (
            <div className={styles.wizardMainWrapper}>
                <Tabs
                    tabs={tabList}
                    tabBarActiveTextColor={'#EB6A1A'}
                >
                    <div className={styles.content}>
                        <h2><span className={styles.bot} />电脑端（Win10流量查询/充值）</h2>
                        <ul>
                            <li>
                                <p>1、选择任务栏右下角的“网络图标”（ <img src={win10_icon1} style={{ width: '0.4rem' }} /> 或 <img src={win10_icon2} style={{ width: '0.4rem' }} />），开启手机网络</p>
                                <img className={styles.wizardImg} src={win10_1} alt="" />
                            </li>
                            <li>
                                <p>2、进入首页网络页查看流量；充值请点击【查看我的账号】</p>
                                <img className={styles.wizardImg} src={win10_2} alt="" />
                            </li>
                            <li>
                                <p>3、点击立即前往，进入移动App首页，可选购套餐充值</p>
                                <img className={styles.wizardImg} src={win10_3} alt="" />
                            </li>
                            <li>
                                <p>4、进入商城首页</p>
                                <img className={styles.wizardImg} src={win10_4} alt="" />
                            </li>
                        </ul>
                    </div>
                    <div className={styles.content}>
                        <h2><span className={styles.bot} />电脑端（Win11流量查询/充值）</h2>
                        <ul>
                            <li>
                                <p>1、点击任务栏右下角的“<img src={win11_icon1} style={{ width: '1rem' }} />”</p>
                                <img className={styles.wizardImg} src={win11_1} alt="" />
                            </li>
                            <li>
                                <p>2、打开手机信号后点击【更多】按钮，<img src={win11_icon2} style={{ width: '0.5rem' }} />进入下一步管理手机网络连接</p>
                                <img className={styles.wizardImg} src={win11_2} alt="" />
                            </li>
                            <li>
                                <p>3、进入手机网络页查看剩余流量；充值请点击【查看我的账户】</p>
                                <img className={styles.wizardImg} src={win11_3} alt="" />
                            </li>
                            <li>
                                <p>4、点击立即前往，进入移动App首页，可选购套餐充值</p>
                                <img className={styles.wizardImg} src={win10_3} alt="" />
                            </li>
                            <li>
                                <p>5、进入商城首页</p>
                                <img className={styles.wizardImg} src={win10_4} alt="" />
                            </li>
                        </ul>
                    </div>
                </Tabs>
            </div>
        )
    }
}